import { mediaUrl } from "./api";

const loaded = new Set();

export const loadFont = (font) => {
  if (!font || loaded.has(font)) return;
  loaded.add(font);
  const l = document.createElement("link");
  l.rel = "stylesheet";
  l.href = `https://fonts.googleapis.com/css2?family=${font.trim().replace(/ /g, "+")}&display=swap`;
  document.head.appendChild(l);
};

// photo-corner / washi colours per theme (default: the theme accent; Classic = kraft paper)
const CORNERS = {
  classic: ["#a47b52", "#c8a67c"], halloween: ["#1b1716", "#d9822b"], christmas: ["#b3262e", "#1f6b3a"],
  new_years: ["#c9a646", "#1c2140"], july4: ["#b3262e", "#1f4e9c"], st_patricks: ["#2e7d32", "#9ccc65"],
  thanksgiving: ["#8a4b1c", "#d08a3a"], hanukkah: ["#2b5fad", "#c0c7d2"],
};

export const themeVars = (t) => {
  const [c1, c2] = CORNERS[t?.key] || (t?.accent ? [t.accent, t.accent] : CORNERS.classic);
  return {
    "--corner": c1,
    "--corner2": c2,
    ...(t ? { "--accent": t.accent, "--title-font": `"${t.font}", "Cormorant Garamond", serif`, "--page-shadow": t.shadow } : {}),
  };
};

export const pageClass = (t) => `ps-${t?.page_style || "corners"}`;

// deterministic ±1.8° tilt from an item id
export const tiltFor = (id = "") => {
  let h = 0;
  for (let i = 0; i < id.length; i += 1) h = (h * 31 + id.charCodeAt(i)) | 0;
  return `${((Math.abs(h) % 37) / 36) * 3.6 - 1.8}deg`;
};

export const bg = (t, v) => (t?.[`bg_${v}`] ? mediaUrl(t[`bg_${v}`]) : null);

export const reducedMotion = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
